import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'reactstrap/lib/Form';
import { injectIntl, intlShape } from 'react-intl';

import {
  withCoreComponent,
  withModalActions,
  withUser
} from 'core/hocs';
import { FormattedTag, FormProvidePhone as FormProvidePhoneCore } from 'core/components';
import { checkIsMobileLengthValidate } from 'helpers/form';
import { ButtonWithLoader } from 'components/button-with-loader/button-with-loader';
import { FormElement } from 'components/form-element/form-element';
import { USER_FIELDS } from 'core/constants';
import { MODAL_IDS } from '../../../constants';

export class FormVerifyPhoneUI extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    fields: PropTypes.shape().isRequired,
    isInProgress: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    isPhoneConfirmed: PropTypes.bool,
    mobilePhone: PropTypes.string,
    userData: PropTypes.shape({ mobilePhone: PropTypes.string }).isRequired,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    isPhoneConfirmed: false,
    mobilePhone: '',
  };

  componentDidUpdate(prevProps) {
    const { isSuccess } = this.props;
    const { isSuccess: isSuccessPrev } = prevProps;

    if (isSuccess && isSuccess !== isSuccessPrev) {
      this.onSuccess();
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { onSubmit, intl } = this.props;
    const smsMessageTemplate = intl?.formatMessage({ id: 'form.confirm-phone.message-template' }) || '';

    onSubmit(e, { isSendSms: true, smsMessageTemplate });
  };

  onSuccess = () => {
    const { closeModal } = this.props;

    closeModal(MODAL_IDS.PROVIDE_MOBILE_PHONE);
  }

  render() {
    const {
      fields,
      isInProgress,
      isPhoneConfirmed,
      mobilePhone,
    } = this.props;

    return (
      <Form
        autoComplete="false"
        onSubmit={this.onSubmit}
        className="d-flex flex-column pt-2 px-3 pb-3_5 w-100"
      >

        <div className="text-center mb-3">
          <FormattedTag
            className="h3 text-center text-uppercase"
            id="form.provide-phone.title"
          />
        </div>

        <FormElement
          coreProps={{ item: fields.mobilePhone }}
          disabled={isPhoneConfirmed}
          isAnimatedPlaceholder
        />

        <FormattedTag
          tag={ButtonWithLoader}
          isLoading={isInProgress}
          type="submit"
          color="primary"
          id="continue"
          className="px-0 mt-2"
          disabled={!checkIsMobileLengthValidate(mobilePhone) || isPhoneConfirmed}
        />
      </Form>
    );
  }
}

export const FormProvidePhone = withCoreComponent(
  FormProvidePhoneCore,
  injectIntl(
    withUser(
      withModalActions(
        FormVerifyPhoneUI
      ), [USER_FIELDS.USER_DATA]
    )
  )
);
